import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';
import moment from 'moment-timezone';
import FormatterCommon from './formatter-common';
import GridFormatterCommon from './grid-formatter-common';
    

    var DATE_FORMAT = 'YYYY-MM-DD hh:mm:ss';

    function CapacityStatusGridFormatter(params, observableOptions) {
        var self = this;
        self.formatterCommon = FormatterCommon;
        self.gridFormatterCommon = new GridFormatterCommon();
        self.observableFormattedData = ko.observable({});
        self.observableOptions = observableOptions;
        self.subscriptions = [];

        var systemType = _.get(params, 'type');
        self.isBridge = (systemType === 'Bridge');
        self.isCallControl = (systemType === 'CallControl');
    }

    CapacityStatusGridFormatter.prototype.DataUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    CapacityStatusGridFormatter.prototype.dispose = function () {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };

    CapacityStatusGridFormatter.prototype.getObservableData = function () {
        var self = this;
        return self.observableFormattedData;
    };

    CapacityStatusGridFormatter.prototype.initialize = function (dataRepository) {
        var self = this;

        self.dataRepository = dataRepository;

        self.subscriptions.push(dataRepository.systemStatusData.subscribe(function () {
            self.DataUpdated();
        }));
        self.subscriptions.push(self.observableOptions.subscribe(function () {
            self.OptionsUpdated();
        }));

        //initialize data if it is there, so that if it isn't a 'loading' icon will show on UI
        if (!_.isEmpty(dataRepository.systemStatusData())) {
            self.RefreshData();
        }
    };

    CapacityStatusGridFormatter.prototype.OptionsUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    CapacityStatusGridFormatter.prototype.RefreshData = function () {
        var self = this;
        self.observableFormattedData(
            composeData(
                self.formatterCommon,
                self.gridFormatterCommon,
                self.dataRepository,
                self.observableOptions()
            )
        );
    };

    function getCapacityRatio(usage, limit) {
        usage = _.toNumber(usage);
        limit = _.toNumber(limit);
        return (limit === 0) ? usage : usage / limit;
    }

    function composeData(formatterCommon, gridFormatterCommon, dataRepository, options) {
        var headers = ['Name', 'Type', 'Status', 'Video Port Capacity', 'Audio Port Capacity'];
        var headersSmall = ['Name', 'Type', 'Status', 'Video %', 'Audio %'];
        var rowProperties = [];
        var widths = ['23%', '8%', '7%', '31%', '31%'];
        var widthsSmall = ['40%', '0%', '14%', '23%', '23%'];
        var sourceList = dataRepository.systemStatusDataMCU();
        var innerheaders = null;
        var innerWidths = null;
        var option = _.get(options, 'category', 'MCU');

         // PEXIP and SKYPE Capacity Status grids support inner grids
        options.showInnerGrid = (option === 'PEXIP' || option === 'SKYPE');

        switch (option) {
            case 'ACANO':
            case 'CMS':
                sourceList = dataRepository.systemStatusDataAcano();
                headers = ['Name', 'Type', 'Hardware', 'Status', 'HD Port License Capacity', 'Spaces', 'Participants'];
                headersSmall = ['Name', 'Type', 'Hardware', 'Status', 'HD Port Cap. %', 'Spaces', 'Participants'];
                widths = ['25%', '8%', '10%', '6%', '31%', '10%', '10%'];
                widthsSmall = ['40%', '0%', '0%', '10%', '20%', '15%', '15%'];
                break;

            case 'BJN':
                sourceList = dataRepository.systemStatusDataBlueJeans();
                headers = ['Name', 'Type', 'Status', 'Total meetings', 'Total participants'];
                headersSmall = ['Name', 'Type', 'Status', 'Meetings', 'Participants'];
                break;

            case 'DMA':
                sourceList = dataRepository.systemStatusDataDMA();
                headers = ['Name', 'Type', 'Status', 'Reg Capacity', 'Call Capacity'];
                headersSmall = ['Name', 'Type', 'Status', 'Reg Cap. %', 'Call Cap. %'];
                break;

            case 'CTPS - Conductor Managed':
                sourceList = dataRepository.systemStatusDataCTPSCondMgd();
                headers = ['Name', 'Type', 'Status', 'Screen Capacity', 'Call Capacity'];
                headersSmall = ['Name', 'Type', 'Status', 'Screen Cap. %', 'Call Cap. %'];
                break;

            case 'CTPS - Standalone':
                sourceList = dataRepository.systemStatusDataCTPSStandalone();
                headers = ['Name', 'Type', 'Status', 'Video Port Capacity', 'Audio Port Capacity'];
                headersSmall = ['Name', 'Type', 'Status', 'Video %', 'Audio %'];
                break;

            case 'CUCM':
                sourceList = dataRepository.systemStatusDataCUCM();
                headers = ['Name', 'Type', 'Status', 'Registered', 'In Call'];
                headersSmall = ['Name', 'Type', 'Status', 'Registered', 'In Call'];
                break;

            case 'PEXIP':
                sourceList = dataRepository.systemStatusDataPexip();
                headers = ['Name', 'Type', 'Status', 'License Capacity', 'Media Load'];
                headersSmall = ['Name', 'Type', 'Status', 'License Cap. %', 'Media Load %'];
                innerheaders = ['#', 'Location', 'Media Load'];
                widths = ['23%', '7%', '6%', '36%', '28%'];
                widthsSmall = ['40%', '0%', '14%', '23%', '23%'];
                break;

            case 'RMX':
                sourceList = dataRepository.systemStatusDataRMX();
                headers = ['Name', 'Type', 'Status', 'Video Port Capacity', 'Audio Port Capacity'];
                headersSmall = ['Name', 'Type', 'Status', 'Video %', 'Audio %'];
                break;

            case 'RPAD':
                sourceList = dataRepository.systemStatusDataRPAD();
                headers = ['Name', 'Type', 'Status'];
                headersSmall = ['Name', 'Type', 'Status'];
                widths = ['60%', '20%', '20%'];
                widthsSmall = ['80%', '0%', '20%'];
                break;

            case 'RPRM':
                sourceList = dataRepository.systemStatusDataRPRM();
                headers = ['Name', 'Type', 'Status'];
                headersSmall = ['Name', 'Type', 'Status'];
                widths = ['60%', '20%', '20%'];
                widthsSmall = ['80%', '0%', '20%'];
                break;

            case 'SKYPE':
                sourceList = dataRepository.systemStatusDataSKYPE();
                headers = ['Name', 'Type', 'Status'];
                headersSmall = ['Name', 'Type', 'Status'];
                widths = ['60%', '20%', '20%'];
                widthsSmall = ['80%', '0%', '20%'];
                innerheaders = ['Component', 'Registered', 'Last Heartbeat', 'Last Register', 'Last Unregister'];
                innerWidths = ['16%', '21%', '21%', '21%', '21%'];
                break;

            case 'VCS':
            case 'VCS Control':
                sourceList = dataRepository.systemStatusDataVCSOnly();
                headers = ['Name', 'Type', 'Status', 'Traversal Capacity', 'Non Traversal Capacity'];
                headersSmall = ['Name', 'Type', 'Status', 'Traversal %', 'Non Traversal %'];
                break;

            case 'VCS Expressway':
            case 'VCSX':
                sourceList = dataRepository.systemStatusDataVCSX();
                headers = ['Name', 'Type', 'Status', 'Traversal Capacity', 'Non Traversal Capacity'];
                headersSmall = ['Name', 'Type', 'Status', 'Traversal %', 'Non Traversal %'];
                break;

            case 'ZOOM':
                sourceList = dataRepository.systemStatusDataZOOM();
                headers = ['Name', 'Type', 'Status', 'CRC License Capacity'];
                headersSmall = ['Name', 'Type', 'Status', 'CRC %'];
                break;

            default:
                break;
        }

        if (_.isEmpty(sourceList)) {
            return {
                headers: headers,
                maxCount: 0,
                rows: [],
                widths: widths
            };
        }
        var list = [];
        var finalList = [];
        var sortableProperties = ['name', 'type', 'status'];

        _.forEach(sourceList, function(item) {
            if (_.isEmpty(options.filter) || _.includes(options.filter, item.name)) {
                switch (option) {
                    case 'ACANO':
                    case 'CMS':
                        sortableProperties = ['name', 'type', 'hardware', 'status', 'licensecapacity', 'cospaces', 'participants'];
                        list.push({
                            cospaces: item.CallsNow,
                            hardware: item.ServerType,
                            host: item.host,
                            id: item.id,
                            licensecapacity: getCapacityRatio(item.MediaTokensNow, item.MediaTokensLimit),
                            mediaTokensLimit: _.toNumber(item.MediaTokensLimit),
                            mediaTokensNow: item.MediaTokensNow,
                            name: item.name,
                            participants: item.ParticipantsNow,
                            status: item.status,
                            type: item.type
                        });
                        break;

                    case 'BJN':
                        list.push(item);
                        break;

                    case 'CTPS - Conductor Managed':
                        sortableProperties = sortableProperties.concat(['licensecapacity', 'callcapacity']);
                        list.push({
                            callcapacity: getCapacityRatio(item.CallNow, item.CallLimit),
                            calllimit: _.toNumber(item.CallLimit),
                            callnow: item.CallNow,
                            host: item.host,
                            licensecapacity: item.LicenseUsage,
                            name: item.name,
                            screenlimit: _.toNumber(item.MediaCreditsLimit / 2560),
                            screensused: (item.MediaCreditsAllocatedNow * 1) / 2560,
                            status: item.status,
                            type: item.type
                        });
                        break;

                    case 'CTPS - Standalone':
                        sortableProperties = sortableProperties.concat(['videoportcapacity', 'audioportcapacity']);
                        list.push({
                            aplimit: _.toNumber(item.AudioOnlyPortLimit),
                            apnow: item.AudioOnlyPortNow,
                            audioportcapacity: getCapacityRatio(item.AudioOnlyPortNow, item.AudioOnlyPortLimit),
                            host: item.host,
                            name: item.name,
                            status: item.status,
                            type: item.type,
                            videoportcapacity: getCapacityRatio(item.VideoPortNow, item.VideoPortLimit),
                            vplimit: _.toNumber(item.VideoPortLimit),
                            vpnow: item.VideoPortNow
                        });
                        break;

                    case 'CUCM':
                        sortableProperties = sortableProperties.concat(['regNow', 'callNow']);
                        list.push({
                            callNow: item.CallNow,
                            host: item.host,
                            name: item.name,
                            regNow: item.RegNow,
                            status: item.status,
                            type: item.type
                        });
                        break;

                    case 'DMA':
                        sortableProperties = sortableProperties.concat(['regcapacity', 'callcapacity']);
                        list.push({
                            callcapacity: getCapacityRatio(item.CallNow, item.CallLimit),
                            callLimit: _.toNumber(item.CallLimit),
                            callNow: item.CallNow,
                            host: item.host,
                            name: item.name,
                            regcapacity: getCapacityRatio(item.RegNow, item.RegLimit),
                            regLimit: _.toNumber(item.RegLimit),
                            regNow: item.RegNow,
                            status: item.status,
                            type: item.type
                        });
                        break;

                    case 'PEXIP':
                        sortableProperties = sortableProperties.concat(['videoportcapacity', 'mediaload']);
                        list.push({
                            host: item.host,
                            mediaload: _.toNumber(item.MediaLoad),
                            name: item.name,
                            status: item.status,
                            type: item.type,
                            videoportcapacity: getCapacityRatio(item.VideoPortNow, item.VideoPortLimit),
                            vplimit: _.toNumber(item.VideoPortLimit),
                            vpnow: item.VideoPortNow,
                            innerTable: getInnerTable({
                                rows: getPexipInnerRows(item, gridFormatterCommon),
                                headers: innerheaders
                            })
                        });
                        break;

                    case 'RMX':
                        sortableProperties = sortableProperties.concat(['videoportcapacity', 'audioportcapacity']);
                        list.push({
                            aplimit: _.toNumber(item.AudioOnlyPortLimit),
                            apnow: item.AudioOnlyPortNow,
                            audioportcapacity: getCapacityRatio(item.AudioOnlyPortNow, item.AudioOnlyPortLimit),
                            host: item.host,
                            name: item.name,
                            status: item.status,
                            type: item.type,
                            videoportcapacity: getCapacityRatio(item.VideoPortNow, item.VideoPortLimit),
                            vplimit: _.toNumber(item.VideoPortLimit),
                            vpnow: item.VideoPortNow
                        });
                        break;

                    case 'RPAD':
                    case 'RPRM':
                        list.push(_.extend({}, item));
                        break;

                    case 'SKYPE':
                        list.push(_.extend({
                            innerTable: {
                                rows: getSkypeInnerRows(item),
                                headers: innerheaders
                            }
                        }, item));
                        break;

                    case 'VCS':
                    case 'VCS Control':
                        sortableProperties = sortableProperties.concat(['traversalcapacity', 'nontraversalcapacity']);
                        list.push({
                            host: item.host,
                            name: item.name,
                            nontraversalcapacity: getCapacityRatio(item.NTCallNow, item.NTCallLimit),
                            ntclimit: _.toNumber(item.NTCallLimit),
                            ntcnow: item.NTCallNow,
                            status: item.status,
                            tclimit: _.toNumber(item.TCallLimit),
                            tcnow: item.TCallNow,
                            traversalcapacity: getCapacityRatio(item.TCallNow, item.TCallLimit),
                            type: item.type
                        });
                        break;

                    case 'VCS Expressway':
                    case 'VCSX':
                        sortableProperties = sortableProperties.concat(['traversalcapacity', 'nontraversalcapacity']);
                        list.push({
                            host: item.host,
                            name: item.name,
                            nontraversalcapacity: getCapacityRatio(item.NTCallNow, item.NTCallLimit),
                            ntclimit: _.toNumber(item.NTCallLimit),
                            ntcnow: item.NTCallNow,
                            status: item.status,
                            tclimit: _.toNumber(item.TCallLimit),
                            tcnow: item.TCallNow,
                            traversalcapacity: getCapacityRatio(item.TCallNow, item.TCallLimit),
                            type: item.type
                        });
                        break;

                    case 'ZOOM':
                        sortableProperties = sortableProperties.concat(['crcCapacity']);
                        list.push(_.extend({
                            crcCapacity: getCapacityRatio(item.CrcPortNow, item.CrcPortLimit)
                        }, item));
                        break;

                    default:
                        sortableProperties = sortableProperties.concat(['videoportcapacity', 'audioportcapacity']);
                        list.push({
                            aplimit: _.toNumber(item.AudioOnlyPortLimit),
                            apnow: item.AudioOnlyPortNow,
                            audioportcapacity: getCapacityRatio(item.AudioOnlyPortNow, item.AudioOnlyPortLimit),
                            host: item.host,
                            name: item.name,
                            status: item.status,
                            type: item.type,
                            videoportcapacity: getCapacityRatio(item.VideoPortNow, item.VideoPortLimit),
                            vplimit: _.toNumber(item.VideoPortLimit),
                            vpnow: item.VideoPortNow
                        });
                        break;
                }
            }
        });

        var sortedList = gridFormatterCommon.sortList(list, sortableProperties, options);
        var pagedList = gridFormatterCommon.pageList(sortedList, options);

        pagedList.forEach(function (item) {
            switch (option) {
                case 'ACANO':
                case 'CMS':
                    rowProperties = ['name', 'type', 'hardware', 'status', 'licensecapacity', 'cospaces', 'participants'];
                    finalList.push({
                        name: gridFormatterCommon.getLinkImageWithName(item.name, item.host),
                        type: item.type,
                        hardware: item.hardware,
                        status: gridFormatterCommon.getStatusMarkup(item.status),
                        licensecapacity: gridFormatterCommon.getProgressBar(((item.mediaTokensLimit / 24).toFixed(1)), ((item.mediaTokensNow / 24).toFixed(1)), null, item.status),
                        cospaces: gridFormatterCommon.getVMRLink(item.cospaces, item.id),
                        participants: item.participants
                    });
                    break;

                case 'BJN':
                    rowProperties = ['name', 'type', 'status', 'meetings', 'participants'];
                    finalList.push({
                        meetings: item.TotalMeetings,
                        name: gridFormatterCommon.getLinkImageWithName(item.name, item.host),
                        participants: item.TotalParticipants,
                        status: gridFormatterCommon.getStatusMarkup(item.status),
                        type: item.type
                    });
                    break;

                case 'CTPS - Conductor Managed':
                    rowProperties = ['name', 'type', 'status', 'licensecapacity', 'callcapacity'];
                    finalList.push({
                        name: gridFormatterCommon.getLinkImageWithName(item.name, item.host),
                        type: item.type,
                        status: gridFormatterCommon.getStatusMarkup(item.status),
                        licensecapacity: gridFormatterCommon.getProgressBarCTPS(item.screenlimit, item.screensused),
                        callcapacity: gridFormatterCommon.getProgressBar(item.calllimit, item.callnow, null, item.status)
                    });
                    break;

                case 'CTPS - Standalone':
                    rowProperties = ['name', 'type', 'status', 'videoportcapacity', 'audioportcapacity'];
                    finalList.push({
                        name: gridFormatterCommon.getLinkImageWithName(item.name, item.host),
                        type: item.type,
                        status: gridFormatterCommon.getStatusMarkup(item.status),
                        videoportcapacity: gridFormatterCommon.getProgressBar(item.vplimit, item.vpnow, null, item.status),
                        audioportcapacity: gridFormatterCommon.getProgressBar(item.aplimit, item.apnow, null, item.status)
                    });
                    break;

                case 'CUCM':
                    rowProperties = ['name', 'type', 'status', 'regNow', 'callNow'];
                    finalList.push({
                        name: gridFormatterCommon.getLinkImageWithName(item.name, item.host),
                        type: item.type,
                        status: gridFormatterCommon.getStatusMarkup(item.status),
                        regNow: item.regNow,
                        callNow: item.callNow
                    });
                    break;

                case 'DMA':
                    rowProperties = ['name', 'type', 'status', 'regcapacity', 'callcapacity'];
                    finalList.push({
                        name: gridFormatterCommon.getLinkImageWithName(item.name, item.host),
                        type: item.type,
                        status: gridFormatterCommon.getStatusMarkup(item.status),
                        regcapacity: gridFormatterCommon.getProgressBar(item.regLimit, item.regNow, null, item.status),
                        callcapacity: gridFormatterCommon.getProgressBar(item.callLimit, item.callNow, null, item.status)
                    });
                    break;

                case 'PEXIP':
                    rowProperties = ['name', 'type', 'status', 'videoportcapacity', 'mediaload'];
                    finalList.push({
                        name: gridFormatterCommon.getLinkImageWithName(item.name, item.host),
                        type: item.type,
                        status: gridFormatterCommon.getStatusMarkup(item.status),
                        videoportcapacity: gridFormatterCommon.getProgressBar(item.vplimit, item.vpnow, 'No valid licenses found', item.status),
                        mediaload: gridFormatterCommon.getProgressBarACANO(1, item.mediaload, item.status),
                        innerTable: item.innerTable,
                        _showInnerPager: false
                    });
                    break;

                case 'RMX':
                    rowProperties = ['name', 'type', 'status', 'videoportcapacity', 'audioportcapacity'];
                    finalList.push({
                        name: gridFormatterCommon.getLinkImageWithName(item.name, item.host),
                        type: item.type,
                        status: gridFormatterCommon.getStatusMarkup(item.status),
                        videoportcapacity: gridFormatterCommon.getProgressBar(item.vplimit, item.vpnow, null, item.status),
                        audioportcapacity: gridFormatterCommon.getProgressBar(item.aplimit, item.apnow, null, item.status)
                    });
                    break;

                case 'RPAD':
                case 'RPRM':
                    rowProperties = ['name', 'type', 'status'];
                    finalList.push({
                        name: gridFormatterCommon.getLinkImageWithName(item.name, item.host),
                        type: item.type,
                        status: gridFormatterCommon.getStatusMarkup(item.status),
                    });
                    break;

                case 'SKYPE':
                    rowProperties = ['name', 'type', 'status'];
                    finalList.push({
                        name: gridFormatterCommon.getLinkImageWithName(item.name, item.host),
                        type: item.type,
                        status: gridFormatterCommon.getStatusMarkup(item.status),
                        innerTable: item.innerTable,
                        _showInnerPager: false
                    });
                    break;

                case 'VCS':
                case 'VCS Control':
                    rowProperties = ['name', 'type', 'status', 'traversalcapacity', 'nontraversalcapacity'];
                    finalList.push({
                        name: gridFormatterCommon.getLinkImageWithName(item.name, item.host),
                        type: item.type,
                        status: gridFormatterCommon.getStatusMarkup(item.status),
                        traversalcapacity: gridFormatterCommon.getProgressBar(item.tclimit, item.tcnow, null, item.status),
                        nontraversalcapacity: gridFormatterCommon.getProgressBar(item.ntclimit, item.ntcnow, null, item.status)
                    });
                    break;

                case 'VCS Expressway':
                case 'VCSX':
                    rowProperties = ['name', 'type', 'status', 'traversalcapacity', 'nontraversalcapacity'];
                    finalList.push({
                        name: gridFormatterCommon.getLinkImageWithName(item.name, item.host),
                        type: item.type,
                        status: gridFormatterCommon.getStatusMarkup(item.status),
                        traversalcapacity: gridFormatterCommon.getProgressBar(item.tclimit, item.tcnow, null, item.status),
                        nontraversalcapacity: gridFormatterCommon.getProgressBar(item.ntclimit, item.ntcnow, null, item.status)
                    });
                    break;

                case 'ZOOM':
                    rowProperties = ['name', 'type', 'status', 'crcCapacity'];
                    finalList.push({
                        name: gridFormatterCommon.getLinkImageWithName(item.name, item.host),
                        type: item.type,
                        status: gridFormatterCommon.getStatusMarkup(item.status),
                        crcCapacity: gridFormatterCommon.getProgressBar(item.CrcPortLimit, item.CrcPortNow, null, item.status)
                    });
                    break;

                default:
                    rowProperties = ['name', 'type', 'status', 'videoportcapacity', 'audioportcapacity'];
                    finalList.push({
                        name: gridFormatterCommon.getLinkImageWithName(item.name, item.host),
                        type: item.type,
                        status: gridFormatterCommon.getStatusMarkup(item.status),
                        videoportcapacity: gridFormatterCommon.getProgressBar(item.vplimit, item.vpnow, null, item.status),
                        audioportcapacity: gridFormatterCommon.getProgressBar(item.aplimit, item.apnow, null, item.status)
                    });
                    break;
            }
        });

        return {
            headers: ($(window).width() < 991) ? headersSmall : headers,
            innerRowDisplayIndex: 0,
            innerWidths: innerWidths,
            maxCount: list.length,
            rowProperties: rowProperties,
            rows: finalList,
            widths: ($(window).width() < 991) ? widthsSmall : widths
        };
    }

    function getInnerTable(innerRow) {
        return {
            headers: ko.observableArray(_.get(innerRow, 'headers')),
            rows: ko.observableArray(_.get(innerRow, 'rows'))
        };
    }

    function getPexipInnerRows(item, gridFormatterCommon) {
        if (!_.has(item, 'SystemLocations')) {
            return [];
        }
        return _.map(JSON.parse(item.SystemLocations), function (location, index) {
            return {
                ind: index,
                name: location.Name,
                mediaLoad: gridFormatterCommon.getProgressBarACANO(1, location.MediaLoad)
            };
        });
    }

    function getSkypeInnerRows(item) {
        if (!_.has(item, 'FrontEndServers')) {
            return [];
        }
        return _.map(JSON.parse(item.FrontEndServers), function (item) {
            return {
                componentName: item.Component,
                registered: item.Registered ? 'True' : 'False',
                lastHeartBeat: moment(item.LastHeartBeat).format(DATE_FORMAT),
                lastRegister: moment(item.LastRegister).format(DATE_FORMAT),
                lastUnregister: moment(item.LastUnregister).format(DATE_FORMAT)
            };
        });
    }

    export default CapacityStatusGridFormatter;
